<template lang="pug">
div.mainWrapper-innerContent
  .mainWrapper-leftContent
    ArticleWithTooltips(:data='data' :visited='visited' :params="config['verifiedArticleBlock']")
    TableBlock(
      :staticData='data.topTenArticles'
      :langInRoute='true'
      type="topTen"
      :params="config['tableBlock'].params"
      :displayLayoutOption='false'
      :displayFilter="config['tableBlock'].displayFilter"
      :displaySort="config['tableBlock'].displaySort"
      :sectionText="data.topTenArticles.title"
      :notBold="true"
    )
    StaticBlock(:partner='data.partner'  :government='data.govPartner' :info='data.static' )
    BottomBanner(:bannerBottomShowBigScreens="true")
  .mainWrapper-rightContent
    .sidebar--right
      StatisticsBlock(:title='data.statistics.title' :items='data.statistics.data' :subText='data.statistics.subText' type='today')
      LatestArticlesBlock(:title='data.latestArticles.title' type="latest" :params="config['latestArticleBlock'].params" :staticData='data.latestArticles')
</template>
<script>
import StatisticsBlock from '@/components/statistics/statistics_block.vue';
import LatestArticlesBlock from '@/components/latest_articles/latest_articles_block.vue';
import TableBlock from '@/components/table/table_block.vue';
import StaticBlock from '@/components/static/static_block.vue';
import ArticleWithTooltips from '@/components/verified_articles/article_with_tooltips.vue';
import BottomBanner from '@/components/bottom_banner.vue';

export default {
  components: {
    TableBlock,
    StatisticsBlock,
    LatestArticlesBlock,
    StaticBlock,
    ArticleWithTooltips,
    BottomBanner
  },
  props: {
    data: Object
  },
  computed: {
    visited() {
      const key = this.$store.state.storageKeys.visited;
      return localStorage.getItem(key);
    }
  },
  data() {
    return {
      config: {
        tableBlock: {
          params: {
            size: 10,
            sort: {
              weight: {
                dir: 'desc',
                default: true
              },
              hottestCount: {
                dir: 'desc',
                default: true
              },
              updatedAt: {
                dir: 'desc',
                default: true
              }
            },
            page: 0
          },
          displayFilter: false,
          displaySort: false
        },
        latestArticleBlock: {
          params: {
            size: 5,
            sort: {
              updatedAt: {
                dir: 'desc',
                default: true
              }
            }
          }
        },
        verifiedArticleBlock: {
          verifiedPartner: {
            size: 4,
            sort: {
              updatedAt: {
                dir: 'desc',
                default: true
              }
            },
            loc: "home"
          },
          verifiedGov: {
            size: 1,
            sort: {
              updatedAt: {
                dir: 'desc',
                default: true
              }
            }
          }
        }
      }
    };
  }
};
</script>
<style>
.mainWrapperXXX {
  display: flex;
  width: 100%;
}
span {
  word-break: break-all;
}
</style>
